import request from "@/utils/api/helpers";

const baseUrl = "/navbar";

export default function getNavbarItems() {
  return request({
    url: `${baseUrl}/items`
  });
}
